import React, { useCallback } from 'react'
import IconButton from '../../../components/IconButton'
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useCustomizer } from '../../../contexts/CustomizerContext'

const LayerSwitch: React.FC<{ unique_id: string }> = ({ unique_id }) => {
    const { activeTemplate, setUserInputs } = useCustomizer()
    const { t } = useTranslation(['settings'])

    const changeLayer = useCallback(
        (unique_id: string, dir: 'up' | 'down') => {
            const canvas = activeTemplate?.canvas
            if (!canvas) return

            const all = canvas.getObjects()
            const obj = all.find(
                (o) =>
                    o.data?.unique_id === unique_id &&
                    o.data?.is_clip_path === false
            )
            if (!obj) return

            // nur sichtbare Layer (ohne Clip-Path) betrachten
            const visibles = all.filter((o) => o.data?.is_clip_path === false)
            const i = visibles.indexOf(obj)
            if (i === -1) return

            let targetIndex: number | null = null
            if (dir === 'up' && i < visibles.length - 1) {
                const sibling = visibles[i + 1]
                targetIndex = all.indexOf(sibling) + 1 // direkt über dem nächsten sichtbaren
            } else if (dir === 'down' && i > 0) {
                const sibling = visibles[i - 1]
                targetIndex = all.indexOf(sibling) // direkt unter dem vorherigen sichtbaren
            }

            if (targetIndex != null) {
                canvas.moveTo(obj, targetIndex)
                canvas.requestRenderAll()
            }

            // userInputs gemäß aktueller sichtbarer Reihenfolge neu aufbauen (ohne `any`)
            setUserInputs((prev) => {
                const order = canvas
                    .getObjects()
                    .filter((o) => o.data?.is_clip_path === false)
                    .map((o) => o.data?.unique_id)
                    .filter((id): id is string => typeof id === 'string')

                const next = new Map(prev)
                next.clear()

                for (const id of order) {
                    const val = prev.get(id)
                    if (val !== undefined) next.set(id, val)
                }
                for (const [id, val] of prev) {
                    if (!order.includes(id)) next.set(id, val)
                }
                return next
            })
        },
        [activeTemplate, setUserInputs]
    )

    return (
        <>
            <IconButton
                icon={faArrowUp}
                color={'black'}
                onClick={() => changeLayer(unique_id, 'up')}
                title={t('layer.moveLayerUp')}
            />
            <IconButton
                icon={faArrowDown}
                color={'black'}
                onClick={() => changeLayer(unique_id, 'down')}
                title={t('layer.moveLayerDown')}
            />
        </>
    )
}

export default LayerSwitch
